const utility = () => import(/* webpackChunkName: "SovMap" */ '../views/Utility/KmlConverter')

const utilityRouter = [
    {
        path: '/kml-converter',
        name: 'kmlconverter',
        component: utility,
        meta: { isLinkAja: true }
    }
]

export default utilityRouter;
